<template>
  <div>
    <div class="mb-5">
      <span class="table__search-input-wrapper">
        <input type="text" v-model="search" class="table__search-input" placeholder="Search..." />
        <svg class="mx-2" width="10" height="5" viewBox="0 0 10 5" fill="none">
          <path d="M0 0L5 5L10 0H0Z" fill="black" />
        </svg>
        <search-icon />
      </span>
      <span class="float-right">
        <Button @click="addLocationModal = true" text="+ New Account" />
      </span>
    </div>
    <b-table-simple head-row-variant="primary" responsive="sm">
      <b-thead>
        <b-tr class="" style="background-color: #f2f7fc">
          <b-th>#</b-th>
          <b-th>.</b-th>
          <b-th>LOCATION NAME</b-th>
          <b-th>ACCOUNTS</b-th>
          <b-th>DEFAULT</b-th>
          <b-th>LAST UPDATED</b-th>
          <b-th><img src="@/assets/images/icons/options-icon.png" alt="" /></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(acc, i) in filterAssociates" :key="i">
          <b-td>{{ i + 1 }}</b-td>
          <b-td>
            <span v-if="acc.isActive">
              <img src="@/assets/images/icons/green-circle.svg" alt="" />
            </span>
            <span v-else>
              <div class="svg-container">
                <Unavailable />
              </div>
            </span>
          </b-td>

          <b-td style="border-bottom: solid 3px #dae8f6; background: white">
            {{ acc.location_name }}
          </b-td>
          <b-td style="border-bottom: solid 3px #dae8f6; background: white">
            <span class="float-left mx-2">
              {{ Object.keys(acc.associateAccounts).length }}
            </span>
            <EyeAccount />
            
          </b-td>
          <b-td style="border-bottom: solid 3px #dae8f6">
            <div v-for="(item, i) in acc.associateAccounts" :key="i">
              <span v-if="item.isDefault">
                {{ item.collectionAccount.account_number }}
                <div>
                  <span style="color: #fcc210; font-size: 12px">{{
                    item.collectionAccount.bank_name
                  }}</span>
                </div>
              </span>
            </div>
          </b-td>
          <b-td>
            <span style="color: #fcc210; font-size: 12px">{{
              acc.updatedAt | formatDate
            }}</span></b-td>
          <b-td style="
              border-bottom: solid 3px #dae8f6;
              background: white;
              align-items: center;
            ">
            <span>
              <el-dropdown>
                <button>
                  <span>
                    <img src="@/assets/images/icons/more.png" alt="" />
                  </span>
                </button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <span  @click="editLocation(acc)">View & Edit</span>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <span v-if="acc.isActive" @click="deactivateLocation(acc)">Deactivate</span>
                    <span v-else @click="activateLocation(acc)">activate</span>
                  </el-dropdown-item>
                  <el-dropdown-item><span @click="deleteLocation(acc.id)">Delete</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown></span></b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <div v-if="associates == []" class="pa-5 my-5">
      <empty-transload-icon class="px-5" description="We Try to standardize shipping costs across our patners.
However, you may wish to adjust your prices to reflect your operational realities.
Note that your service costs may appear lower or higher than our standard service cost, subject to your settings.

You are currently using MuleEx Standardized Shipping Prices" />
    </div>
    <!-- Add New Location Modal -->
    <modal title="Associate Accounts" @close-modal="addLocationModal = false" :showModal="addLocationModal"
      id="addLocation" width="500">
      <div class="container">
        <div v-for="(location, i) in newLocation" :key="i">
          <div class="row mt-3 justify-content-center">
            <div class="col-md-12">
              <span class="">
                <label for="banks" style="font-weight: 400; font-size: 16px">Select Location:
                </label>
                <select class="form-control" v-model="location.locationDetails" placeholder="Select Location" name=""
                  id="">
                  <option :value="{
                    locationId: location.id,
                    location_name: location.locationName,
                  }" v-for="location in locations" :key="location.id">
                    {{ location.locationName }}
                  </option>
                </select>
              </span>
            </div>
          </div>
          <div>
            <div class="row mt-3 justify-content-center">
              <div class="col-md-12">
                <span class="">
                  <label for="banks" style="font-weight: 400; font-size: 16px">Account:
                  </label>
                  <form-select selected="" placeholder="--Select--">
                    <b-form-checkbox v-for="(b, i) in accounts" :key="i" :id="b.id" v-model="location.accounts"
                      :name="b.bank_name" :value="{
                        id: b.id,
                        bank_name: b.bank_name,
                        account_number: b.account_number,
                      }">
                      <span class="float-left">{{ b.bank_name }} | {{ b.account_number }}
                      </span>
                    </b-form-checkbox>
                  </form-select>
                </span>
              </div>
            </div>
            <div class="row mt-3">
              <div v-for="(acc, i) in location.accounts" :key="i" class="col mr-2 mt-2" style="
                  width: auto;
                  background: #f3f6f9;
                  height: 41px;
                  padding: 3px 13px 3px 13px;
                ">
                <div class="row justify-content-center" style="line-height: 19.07px">
                  <div class="col-sm-9 pl-3">
                    <span class="text-nowrap" style="font-size: 14px; margin-bottom: 0px">{{ acc.account_number
                      }}</span>
                    <br />
                    <span style="color: #fcc210; font-size: 14px">{{
                      acc.bank_name
                    }}</span>
                  </div>
                  <div class="col-sm-3 my-1">
                    <svg @click="removeAccount(i)" class="" style="width: 24px; height: 24px" viewBox="0 0 24 24">
                      <path fill="#A5ADB7"
                        d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3" v-if="newLocation.length > 1">
            <div class="col">
              <Button class="float-right" @click="removeLocation(i)" text="- Remove Location"
                style="color: red; font-size: 14px; font-weight:600" background="white" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <hr style="color: #b7bdcd" />
            </div>
          </div>
        </div>

        <div class="row my-4">
          <div class="col">
            <Button @click="addNewLocation()" text="+ Add Location"
              style="color: #fcc210; font-size: 14px; font-weight:600" background="white" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <Button @click="addLocation" text="Update" type="submit" class="float-right" />
          </div>
        </div>
      </div>
    </modal>
    <!-- Edit Location Modal -->
    <modal title="Associate Accounts" @close-modal="editLocationModal = false" :showModal="editLocationModal"
      id="addLocation" width="500">
      <div class="container">
        <div>
          <div class="row mt-3 justify-content-center">
            <div class="col-md-12">
              <span class="">
                <label for="banks" style="font-weight: 400; font-size: 16px">Location:
                </label>

                <select class="form-control" type="select" v-model="selectedLocation.location_name"
                  placeholder="Select Location" name="" id="">
                  <option :value="location.locationName" v-for="location in filterLocation" :key="location.id">
                    {{ location.locationName }}
                  </option>
                </select>
              </span>
            </div>
          </div>
          <div>
            <div class="row mt-3 justify-content-center">
              <div class="col-md-12">
                <span class="">
                  <label for="banks" style="font-weight: 400; font-size: 16px">Account:
                  </label>
                  <form-select placeholder="--Select--">
                    <b-form-checkbox v-for="(b, i) in selectedLocation.associateAccounts" :key="i" :id="b.id"
                      v-model="selectedLocation.associateAccounts" :name="b.bank_name" :value="{
                        id: b.id,
                        bank_name: b.bank_name,
                        account_number: b.account_number,
                      }">
                      <span class="float-left">
                        {{ b.collectionAccount.bank_name }} |
                        {{ b.collectionAccount.account_number }}
                      </span>

                      <Button v-if="b.isDefault" class="float-right" text="Default" background="white"
                        style="color: #09b78a; font-size: 10px" />
                      <Button v-else @click="defaultAssociate(b)" class="float-right" text="set as default"
                        background="white" style="color: #fcc210; font-size: 10px" />
                    </b-form-checkbox>
                  </form-select>
                </span>
              </div>
            </div>
            <div class="row mt-3">
              <div v-for="(acc, i) in selectedLocation.associateAccounts" :key="i" class="col mr-2 mt-2" style="
                  width: auto;
                  background: #f3f6f9;
                  height: 41px;
                  padding: 3px 13px 3px 13px;
                ">
                <div class="row justify-content-center" style="line-height: 19.07px">
                  <div class="col-sm-9 pl-3">
                    <span class="text-nowrap" style="font-size: 14px; margin-bottom: 0px">{{
                      acc.collectionAccount.account_number }}</span>
                    <br />
                    <span style="color: #fcc210; font-size: 14px">{{
                      acc.collectionAccount.bank_name
                    }}</span>
                  </div>
                  <div class="col-sm-3 my-1">
                    <svg @click="removeAccount(i)" class="" style="width: 24px; height: 24px" viewBox="0 0 24 24">
                      <path fill="#A5ADB7"
                        d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <hr style="color: #b7bdcd" />
            </div>
          </div>
        </div>

        <div class="row my-4"></div>
        <div class="row">
          <div class="col">
            <Button @click="saveEdit()" text="Update" type="submit" class="float-right" />
          </div>
        </div>
      </div>
    </modal>
    <pagination :total="totalAssociates" :pageNumber="pageNumber" @pageNumber="setNumDisplaySettlement"
      @pageSize="setPageDisplaySettlement" />
  </div>
</template>

<script>
import Modal from "../Modal.vue";
import Pagination from "@/components/UI/pagination";

import Unavailable from "@/components/svg-icons/Unavailable.vue";
import EyeAccount from "@/components/svg-icons/PricingAccEyeIcon.vue";


import Button from "@/components/UI/BaseButton.vue";
export default {
  components: {
    EyeAccount,
    Unavailable,
    Button,
    Pagination,
    // Tooltip,
    Modal,
  },
  data() {
    return {
      totalAssociates: 1,
      pageNumber: 1,
      pageSize: 10,
      estimatedCost: 30000,
      selectedAccount: [],
      accounts: [],
      locationModel: "",
      associates: [],
      selectedLocation: [],
      showMore: false,
      search: "",
      locations: [],
      allSelected: false,
      indeterminate: false,
      editLocationModal: false,
      addLocationModal: false,
      showRoutes: false,
      editedLocation: [
        {
          locationDetails: "",
          accounts: [],
        },
      ],
      newLocation: [
        {
          locationDetails: "",
          accounts: [],
        },
      ],
      banks: [],
      fields: [
        {
          key: "route",
          label: "Account Name",
        },
        {
          key: "dateModified",
          label: "Date Modified",
        },
        {
          key: "modifiedBy",
          label: "Modified By",
        },
        {
          key: "menuIcon",
          label: "",
        },
      ],
    };
  },
  mounted() {
    this.getLocation();
    this.getAccounts();
    this.getAssociates();
  },
  methods: {
    setNumDisplaySettlement(val) {
      this.pageNumber = val;
    },
    setPageDisplaySettlement(val) {
      this.pageSize = val;
    },
    addNewLocation() {
      this.newLocation.push({
        locationId: "004e22e0-2a0e-4eb0-ac45-b6d52d524cab",
        location_name: "",
        accounts: [],
      });
    },
    removeLocation(i) {
      this.newLocation.splice(i, 1);
    },
    async defaultAssociate(b) {
      try {
        await this.$_defaultAssociate({
          id: b.id,
          collectionAssociateId: b.collectionAssociateId,
        });
        this.getAssociates();
        this.editedLocation();
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    removeAccount(i) {
      for (let index = 0; index < this.newLocation.length; index++) {
        const element = this.newLocation[index];

        element.accounts.splice(i, 1);
        // console.log(JSON.stringify(element.accounts, null, 2))
      }
    },
    editLocation(acc) {
      this.editLocationModal = true;
      this.selectedLocation = { ...acc };
      this.locationModel = {
        locationId: this.selectedLocation.id,
        location_name: this.selectedLocation.location_name,
      };
    },

    async deleteLocation(acc) {
      try {
        await this.$_deleteAssociate(acc);
        this.getAssociates();
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async deactivateLocation(acc) {
      try {
        let payload = {
          locationId: acc.locationId,
          location_name: acc.locationName,
          isActive: false,
        };
        await this.$_editAssociate(payload, acc.id);
        this.editLocationModal = false;
        this.getAssociates();
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async activateLocation(acc) {
      try {
        let payload = {
          locationId: acc.locationId,
          location_name: acc.locationName,
          isActive: true,
        };
        await this.$_editAssociate(payload, acc.id);
        this.editLocationModal = false;
        this.getAssociates();
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async saveEdit() {
      try {
        // let orgId = localStorage.getItem("organizationId");
        // let user_id = localStorage.getItem("userId");
        var editedLocation = this.filterLocation.find(
          (location) =>
            location.locationName === this.selectedLocation.location_name
        );
        let payload = {
          locationId: editedLocation.id,
          location_name: editedLocation.locationName,
        };
        await this.$_editAssociate(payload, this.selectedLocation.id);
        this.editLocationModal = false;
        this.getAssociates();
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async addLocation() {
      try {
        let orgId = localStorage.getItem("organizationId");
        let user_id = localStorage.getItem("userId");

        for (let index = 0; index < this.newLocation.length; index++) {
          let element = this.newLocation[index];
          let locationId = element.locationDetails.locationId;
          let location_name = element.locationDetails.location_name;
          let accounts = element.accounts.map((acc) => acc.id);

          let associates = [
            {
              locationId: locationId,
              location_name: location_name,
              accounts: accounts,
            },
          ];
          console.log(JSON.stringify(associates, null, 2));
          let payload = {
            orgId: orgId,
            user_id: user_id,
            associates: associates,
          };
          await this.$_createAssociate(payload);
          this.addLocationModal = false;
          this.getAssociates();
        }
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async getLocation() {
      try {
        let orgId = localStorage.getItem("organizationId");
        let response = await this.$_getLocation(orgId);

        this.locations = response.data.data.locations;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    async getAssociates() {
      try {
        let response = await this.$_getAssociates({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        });
        this.associates = response.data.data.account;
        this.totalAssociates = response.data.data.totalCount;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    async getAccounts() {
      try {
        let orgId = localStorage.getItem("organizationId");

        let response = await this.$_getAccounts(orgId);
        this.accounts = response.data.data.accounts.filter(
          (acc) => acc.bank_name !== ""
        );
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
  },
  computed: {
    filterAssociates() {
      return this.filterArray(this.associates, this.search);
    },
    filterLocation() {
      return this.locations.map((location) => {
        return {
          id: location.id,
          locationName: location.locationName,
        };
      });
    },
  },
  watch: {
    estimatedCost(val) {
      this.estimatedCost = val;
    },
    pageNumber(val) {
      this.pageNumber = val;
      this.getAssociates();
    },
    pageSize(val) {
      this.pageSize = val;
      this.getAssociates();
    },
  },
};
</script>

<style scoped>
.svg-container {
  background-color: #878E99;
  display: inline-block;
  /* Keeps the size to the content */
  padding: 3px;
  border-radius: 50%;
}

.table__search-input-wrapper {
  align-items: center;
  display: inline-flex;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 380px;
  border-radius: 15px;
  padding: 0 1rem;
  margin-right: 1.5rem;
}

.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}

.table__search-input:focus {
  outline: none;
}

.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}

.button {
  border-radius: 15px;
  padding: 0 1rem;
}

@media screen and (max-width: 768px) {
  .table__search-input-wrapper {
    width: 100%;
  }

  .table__btn-wrapper {
    width: 100%;
  }

  .button {
    width: 100%;
    margin-bottom: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
</style>
